
  import pwa from '~/mixins/pages/pwa'
  import { PIXEL_EVENTS } from '~/utils/constants'
  export default {
    name: 'ThemeStoresMobileAndroidAppSection',
    mixins: [pwa],
    computed: {
      pwa() {
        return this.$store.state['banner-pwa'].pwa
      },
      appIcon() {
        if (!this.pwa?.pwa_app_settings?.app_icon) return null
        return `${this.$config.BUCKET_ROOT}/assets/banners/app_icons/${this.pwa?.pwa_app_settings?.app_icon}`
      }
    },
    methods: {
      async installApp() {
        this.trackPixelEvent(PIXEL_EVENTS.downloadAction, null, null, null, false, null, true)
        const deferredPrompt = window.homeScreenDeferredPrompt
        if (deferredPrompt) {
          deferredPrompt.prompt()
          // Optionally, handle the user's choice
          const { outcome } = await deferredPrompt.userChoice
          console.log('User response to the install prompt:', outcome)
          // Clear the saved prompt (it can only be used once)
          window.homeScreenDeferredPrompt = null
        }
      }
    }
  }
